
























































































































































import { Component, Vue } from 'vue-property-decorator'
import { BRow, BCol, BFormCheckbox, BIconX } from 'bootstrap-vue'
import cloneDeep from 'lodash/cloneDeep'

import ProductsApi from '@cms-labs/typescript-api/products'
import { ProductItemPublic } from '@cms-labs/typescript-api/products/types'

import store from '../store'
import { app } from '../main'
import { CartItem } from '../store/cart/types'
import CheckoutButton from '@/components/CheckoutButton.vue'
import LoadingOverlay from '@/components/LoadingOverlay.vue'

@Component({
  components: {
    CheckoutButton,
    BRow,
    BCol,
    BIconX,
    BFormCheckbox,
    LoadingOverlay
  }
})
export default class CartPage extends Vue {
  private isLoading = false
  private areTermsAccepted = false

  private async created (): Promise<void> {
    try {
      this.isLoading = true
      await this.checkCartItemsUpToDate()
      this.isLoading = false
    } catch (error) { this.isLoading = false }
  }

  private updateItemQuantity (uuid: string, qty: number): void {
    if (Number.isInteger(qty) && qty > 0) {
      store.cart.updateItemQuantity(uuid, qty)
    }
  }

  private async checkCartItemsUpToDate (): Promise<void> {
    const http = new ProductsApi(app)
    for (const localItem of this.cartItems) {
      try {
        const cloudItem: ProductItemPublic = await http.getProductInstance(localItem.uuid)
        if (
          (localItem.stock && localItem.stock < 1) ||
          localItem.name !== cloudItem.name ||
          localItem.price !== cloudItem.price ||
          localItem.discount_pct !== cloudItem.discount_pct
        ) {
          store.cart.removeItem(localItem.uuid)
          this.$bvToast.toast(
            'Porfavor vuelva a agregar los productos en su carrito', {
              title: 'La info. de su producto está desactualizada.',
              variant: 'danger',
              autoHideDelay: 8000
            }
          )
        }
      } catch (error) {
        if (error.response.status === 404) {
          store.cart.removeItem(localItem.uuid)
          this.$bvToast.toast(
            'Porfavor vuelva a agregar los productos en su carrito', {
              title: 'Ciertos productos ya no están disponibles.',
              variant: 'danger',
              autoHideDelay: 8000
            }
          )
          this.isLoading = false
        }
      }
    }
  }

  public removeItem (uuid: string): void {
    store.cart.removeItem(uuid)
  }

  public get cartItems (): CartItem[] {
    return cloneDeep(store.cart.items)
  }

  public get orderTotal (): number {
    return store.cart.orderTotal
  }

  public get itemsCount (): number { return store.cart.itemsCount }

  private get formIsCorrect (): boolean {
    return !this.areTermsAccepted
  }
}
